import {
  // Fragment, 
  useState , useEffect} from "react";
import {useDispatch} from "react-redux";
import toast from "react-hot-toast";
import { useForm } from "react-hook-form";
import {useNavigate} from "react-router-dom";


import AppSphereLoader from "../../../components/loaders/AppSphereLoader";
// import ArrowBackSvg from "../../../assets/images/svg/arrow-back.svg";
import * as ProfileConstants from "../../../store/constants/profile.constants";
import ActionCreator from "../../../utils/helpers/actionCreator";
// import DynamicFields from "../../../components/dynamicFields/DynamicFields";
import {getProfile} from "../../../store/actions/profile.action";
import ProfileService from "../../../utils/services/profile.service";
import {DomStateType, 
  // InputType, 
  Loading} from "../../../utils/helpers/constants";

const Body = () => {

  const dispatch = useDispatch(), navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const goBack = () => navigate(-1);
 
  const useFormHook = useForm({
    defaultValues: {},
    mode: "all",
    reValidateMode: "onChange",
    criteriaMode: "firstError",
  });

  const setVehicleOwnerProfile = vehicleOwnerProfile => {
    let newState = { type: DomStateType.VEHICLE_OWNER, id: vehicleOwnerProfile.id, vehicleOwnerProfile };
    dispatch(ActionCreator(ProfileConstants.SET_DOM_PROFILE, newState));
  }

  const onboardVehicleOwner = async () => {
      setLoading(true);
      const payload = { ...useFormHook.getValues() };
      const { data: responseData } = await ProfileService.createVehicleOwnerProfile({ dynamic_fields: payload });
      if (responseData.status !== Loading.SUCCESS) {
        const message = (responseData && responseData.message) ? responseData.message : "You cannot onboard your vehicle owner profile at the moment, please try again later";
        toast.error(message);
        goBack();
      }
      else {
        await dispatch(getProfile());
        await setVehicleOwnerProfile(responseData.data);
        toast.success(responseData.message);
        await navigate('/register-vehicle');
      }
      setLoading(false);
    }

  useEffect(() => {
    onboardVehicleOwner();
  },[])

  // const dynamicFields = [
    //     {
    //         key: "nin",
    //         name: "NIN",
    //         type: "text",
    //         label: "Nin",
    //         unique: true,
    //         default: false,
    //         options: [],
    //         required: false,
    //         max_length: "11",
    //         min_length: "11",
    //         placeholder: "National Identification Number (N.I.N)",
    //         hidden_field: false,
    //         verify_object: false
    //     }
    // ]


  // const renderDynamicFields = dynamicFields.map((eachField, index) => (
  //   <Fragment key={index}>
  //     {(eachField.type !== InputType.FILE && !eachField['hidden_field']) &&
  //       <DynamicFields divClass="custom position-relative w-100 mg-t-15 mb-3" key={index}
  //         formControl={eachField} formHook={useFormHook}/>
  //     }
  //   </Fragment>
  // ));

  return loading ? <AppSphereLoader/> : <></>

  // return (
  //   <div className="booking py-4 bg-white d-flex flex-column">
  //     <p className="mb-0 booking-direct fs-18 pointer-event" onClick={goBack}>
  //       <img src={ArrowBackSvg} alt="Arrow-back"/> &nbsp; Go Back
  //     </p>
  //     <div className="pb-5 pt-3">
  //       <div className="booking-main d-flex flex-column">
  //         <h3 className="booking-title pt-0">Set up your vehicle Owner profile</h3>
  //         <form className="booking-form d-flex mt-4 flex-column align-items-start">
  //           {renderDynamicFields}
  //           <button className="btn main-btn mt-4" onClick={useFormHook.handleSubmit(onboardVehicleOwner)} type="button">
  //             Set up profile
  //             {loading && <>&nbsp;<i className="zmdi zmdi-spinner ms-2 mg-l-1 zmdi-hc-spin"/></>}
  //           </button>
  //         </form>
  //       </div>
  //     </div>
  //   </div>
  // );

}

export default Body;
